import logo from './tbd-logo.webp';
import apps from './apps.webp';
import web from './web.webp';
import brand from './brand.webp';
import './About.css';

function About() {
  return (
    <div className="about-page">
      

      {/* Main Content */}
      <main className="about-main">
        {/* Our Story Section */}
         <section className="about-hero">
        <div className="about-hero-content">
          <h1>The Story of the Star</h1>
        </div>
      </section>
        <section className="about-section">
          <div className="container">
            <img src={logo} alt="Trailblaze Digital Logo" className="about-logo" />
            <p>
              The Trailblaze logo features a bold, futuristic design centered around a stylized red explosion or starburst motif, 
              symbolizing innovation, impact, and forward momentum. 
              The graphic is layered over a circular frame with sharp angular elements, 
              suggesting energy and direction—qualities essential to trailblazing paths in media, 
              technology, or digital landscapes.
              The word "TRAILBLAZE" is prominently displayed in a sleek, 
              modern typeface with rounded, digital-style lettering. 
              The characters are bisected by two horizontal lines that extend beyond the text, 
              adding a sense of structure and motion. The vibrant red and black color palette conveys power, 
              creativity, and determination, while the abstract patterns within the central burst add texture 
              and depth, giving the logo a distinctive and memorable appearance.
            </p>
            <p>
              What started as a mission to level the playing field has evolved into a comprehensive 
              digital creative studio that combines cutting-edge technology with human creativity to 
              deliver results that matter.
            </p>
          </div>
        </section>

        {/* Our Mission Section */}
        <section className="about-section mission-section">
          <div className="container">
            <h2>Our Mission</h2>
            <div className="mission-content">
              <div className="mission-text">
                <p>
                  We believe every business deserves to shine in the digital landscape. Our mission is to 
                  empower entrepreneurs and growing companies with world-class creative solutions that 
                  drive real growth and meaningful connections with their audiences.
                </p>
              </div>
              <div className="mission-values">
                <h3>Our Core Values</h3>
                <ul>
                  <li><strong>Innovation:</strong> Staying ahead of digital trends and technologies</li>
                  <li><strong>Quality:</strong> Never compromising on excellence in our deliverables</li>
                  <li><strong>Partnership:</strong> Working as an extension of your team</li>
                  <li><strong>Results:</strong> Focusing on measurable outcomes that matter</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* What We Do Section */}
        <section className="about-section services-overview">
          <div className="container">
            <h2>What We Do</h2>
            <div className="services-grid">
              <div className="service-card">
                <img src={apps} alt="App icon" className="apps-logo" />
                <h3>UI/UX Design for Apps</h3>
                <p>
                 We craft app experiences that are not only visually appealing but also 
                 intuitive and user-friendly. Our designs focus on functionality, 
                 engagement, and seamless user journeys that keep people coming back..
                </p>
              </div>
              <div className="service-card">
                <img src={web} alt="Website Logo" className="web-logo" />
                <h3>High-Converting Websites</h3>
                <p>
                  From design to deployment, we build websites that turn visitors into customers 
                  with intuitive UX and compelling copy.
                </p>
              </div>
              <div className="service-card">
                <img src={brand} alt="Brand Logo" className="brand-logo" />
                <h3>Branded Content Creation</h3>
                <p>
                  Consistent, engaging content that tells your story and builds lasting 
                  relationships with your audience across all platforms.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}



export default About;